import type { FaireProductEntity } from "../../entity_types/product";

export const p_2kvw6k2z84: FaireProductEntity = {
  token: "p_2kvw6k2z84",
  type: "product",
  name: "Breathe Easy Salve | Natural Vapor Rub | Chest Rub",
  brandToken: "b_vt9rkhen92",
  brandName: "Dandelion Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/fb0a55604fafb5da29cd2a856773884d27b9cb2a0affce904477e4b3d760e07a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3e7f299b57d75c7a2502aeaa3194334e84947afb3c89870874cd654b3a721082.jpeg",
    "https://cdn.faire.com/fastly/4402dada0743eccc01d61cce2ed792703dcca621545141fc8caf127e31a52ef4.jpeg",
    "https://cdn.faire.com/fastly/a86d9a30c255e692bc127a1a4485efd3a6105fe5fa3041955e9075700ff2d1ac.jpeg",
  ],
  priceDollars: 6,
  description:
    "Our Breathe Easy, Herbal Chest Rub is an all-natural vapor rub made of a powerful blend of respiratory supporting herbs, menthol crystals and pure essential oils. Rub on the chest, back, sinuses, temples, and bottoms of feet to support and aid the body during times of illness with chest congestion, cough, troubles sleeping at night and cold and flu symptoms. Relax the body and breath in the natural and comforting aroma for added respiratory support. This rub is medicinal strength and goes a long way. Avoid the eyes. Not intended for small children.\n\nIngredients: Olive Oil infused with Red Clover Blossoms, Mullein Leaf, Peppermint Leaf, and Oregano Leaf. Menthol Crystals, 100% Pure Local Beeswax, Essential Oil Blend of Peppermint, Eucalyptus, Camphor, Rosemary, Fennel, & Thyme.",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:33.799Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
